/**
 * Polyfills for ES2023 "change array by copy" methods.
 * Needed for older browsers (Safari < 16, Chrome < 110, Firefox < 115).
 * Import this file once at the top of _app.tsx.
 */

if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function <T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
    return this.slice().sort(compareFn)
  }
}

if (!Array.prototype.toReversed) {
  Array.prototype.toReversed = function <T>(this: T[]): T[] {
    return this.slice().reverse()
  }
}
